var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4687_7670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73242 21.3564C10.1659 22.1646 11.0188 22.7143 12 22.7143C12.9813 22.7143 13.8341 22.1646 14.2676 21.3564",
    stroke: "#703115",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30669 3.23006C8.55137 1.98539 10.2395 1.28613 11.9998 1.28613C13.76 1.28613 15.4481 1.98539 16.6928 3.23006C17.9375 4.47474 18.6368 6.16288 18.6368 7.92313C18.6368 8.95883 18.8077 9.93203 19.0648 10.9275C19.1368 11.1528 19.2162 11.3654 19.3016 11.5661C19.6993 12.5017 20.7944 12.8209 21.6116 13.4258C22.8313 14.3288 22.5954 16.2608 21.5809 17.0109C21.5809 17.0109 19.9429 18.429 11.9998 18.429C4.05655 18.429 2.41858 17.0109 2.41858 17.0109C1.40409 16.2608 1.16829 14.3288 2.38796 13.4258C3.20508 12.8209 4.30016 12.5017 4.698 11.5661C5.09455 10.6336 5.36276 9.4406 5.36276 7.92313C5.36276 6.16288 6.06202 4.47474 7.30669 3.23006Z",
    fill: "#f6e6cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30669 3.23006C8.55137 1.98539 10.2395 1.28613 11.9998 1.28613C13.76 1.28613 15.4481 1.98539 16.6928 3.23006C17.9375 4.47474 18.6368 6.16288 18.6368 7.92313C18.6368 8.95883 18.8077 9.93203 19.0648 10.9275C19.1368 11.1528 19.2162 11.3654 19.3016 11.5661C19.6993 12.5017 20.7944 12.8209 21.6116 13.4258C22.8313 14.3288 22.5954 16.2608 21.5809 17.0109C21.5809 17.0109 19.9429 18.429 11.9998 18.429C4.05655 18.429 2.41858 17.0109 2.41858 17.0109C1.40409 16.2608 1.16829 14.3288 2.38796 13.4258C3.20508 12.8209 4.30016 12.5017 4.698 11.5661C5.09455 10.6336 5.36276 9.4406 5.36276 7.92313C5.36276 6.16288 6.06202 4.47474 7.30669 3.23006Z",
    stroke: "#703115",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4687_7670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.7304d96c8e804ba76fd5351c192f56c6.svg";
export { ForwardRef as ReactComponent };